const state = {
    token: '',
    uid: ''
}
export default state


// WEBPACK FOOTER //
// ./src/store/state.js